import { useState, useEffect } from 'react'
import getMemberSummary from '../api/loyalty/getMemberSummary'

export const useLoyaltyMemberSummary = ({ accessToken, enabled }) => {
  const [totalPoints, setTotalPoints] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loyaltyCardCode, setLoyaltyCardCode] = useState(null)

  useEffect(() => {
    if (!enabled || !accessToken) {
      setTotalPoints(null)
      return
    }
    setLoading(true)
    getMemberSummary({ accessToken })
      .then(res => {
        setTotalPoints(res?.data?.data?.redeemablePoints ?? null)
        setLoyaltyCardCode(res?.data?.data?.loyaltyCardCode ?? null)
      })
      .catch(() => setTotalPoints(null))
      .finally(() => setLoading(false))
  }, [accessToken, enabled])

  return { totalPoints, loading, loyaltyCardCode }
}
